import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';
import clinicalHypnotherapy from '../../../../../assets/images/ClinicalHypnotherapy.webp';
import { Section, ContentContainer, SectionImage } from '../../styles';
import {
  HypnotherapyHeading,
  HypnotherapyIntroText,
  HypnotherapySecondText,
  HypnotherapyDisclaimerText,
  HypnotherapyCtaWrapper,
  HypnotherapyCTAButton,
} from './styles';
import {
  TwoColumnLayoutCentered,
  CardsContainer,
  StepCardRow,
  NumberIconResponsive,
  CardContentWrapper,
  StepCardTitle,
  StepCardDescription,
} from '../../../../../components/StepCardLayout/styles';
import { hypnotherapyfaq } from '../../constants';

const HypnotherapySection = () => {
  const navigate = useNavigate();
  const navigateToServices = () => {
    navigate('/services');
  };

  return (
    <Section>
      <ContentContainer>
        <HypnotherapyHeading>What is Clinical Hypnotherapy?</HypnotherapyHeading>

        <HypnotherapyIntroText>
          Clinical hypnotherapy is a professional, guided use of hypnosis—a natural, focused state
          of attention— to help you access the subconscious and create meaningful, lasting change.
        </HypnotherapyIntroText>

        <HypnotherapySecondText>
          In this state, your mind becomes more open to beneficial suggestions aligned with your
          goals, allowing you to transform patterns, improve daily functioning, and activate
          motivation from the inside out.
        </HypnotherapySecondText>

        <TwoColumnLayoutCentered>
          <Box>
            <CardsContainer>
              {hypnotherapyfaq.map((step) => (
                <StepCardRow key={step.number}>
                  <NumberIconResponsive>{step.number}</NumberIconResponsive>
                  <CardContentWrapper>
                    <StepCardTitle>{step.title}</StepCardTitle>
                    <StepCardDescription>{step.description}</StepCardDescription>
                  </CardContentWrapper>
                </StepCardRow>
              ))}
            </CardsContainer>
          </Box>

          <Box>
            <SectionImage src={clinicalHypnotherapy} alt="Hypnotherapy Session" />
          </Box>
        </TwoColumnLayoutCentered>

        <HypnotherapyDisclaimerText>
          Results vary by person; many clients describe hypnotherapy as
          <br />
          calming, clarifying, and practically helpful.
        </HypnotherapyDisclaimerText>

        <HypnotherapyCtaWrapper>
          <HypnotherapyCTAButton onClick={navigateToServices} text="Explore Our Services" />
        </HypnotherapyCtaWrapper>
      </ContentContainer>
    </Section>
  );
};

export default HypnotherapySection;
